import React from 'react';
import { useTranslation } from 'react-i18next';

import './Smile.scss';

import SectionTitle from '../../components/SectionTitle/SectionTitle';

import EmergencyImg from '../../assets/emergency.webp';

const Smile = () => {
    const { t } = useTranslation();

    return (
        <section
            className="emergency-section"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container-fluid">

                <div className="row align-items-center">

                    <div className="col-lg-6 col-md-6">
                        <div className="emergency-img">
                            <img
                                src={EmergencyImg}
                                alt={t('smile.imageAlt')}
                            />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">
                        <div className="emergency-text">

                            <SectionTitle
                                title={t('smile.title')}
                                description={t('smile.description')}
                            />

                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default Smile;